import { FaLeaf } from "react-icons/fa";
import FoodDetailThemeBase from "./FoodDetailThemeBase";

const GREEN = "#3F5A3D";
const TERRACOTTA = "#B0552F";

const theme = {
  pageStyle: { backgroundColor: "#F6F2E7" },
  headerClassName: "sticky top-0 z-20",
  headerStyle: { backgroundColor: GREEN },
  headerInnerClassName: "mx-auto flex h-16 max-w-2xl items-center justify-between px-4 text-white",
  iconButtonClassName: "flex h-11 w-11 items-center justify-center rounded-xl text-xl hover:bg-white/10 focus:outline-none focus:ring-2 focus:ring-white",
  titleClassName: "font-black",
  badgeClassName: "absolute -left-1 -top-1 rounded-full bg-white px-1.5 text-[10px] font-bold",
  badgeStyle: { color: GREEN },
  cardClassName: "overflow-hidden rounded-3xl bg-white shadow-sm",
  PlaceholderIcon: FaLeaf,
  placeholderClassName: "flex aspect-[4/3] items-center justify-center text-6xl sm:aspect-[16/9]",
  placeholderStyle: { backgroundColor: "#EFE9D8", color: "#8CA37E" },
  itemTitleClassName: "font-serif text-2xl font-black text-gray-900",
  descriptionClassName: "mt-3 leading-7 text-gray-600",
  priceStyle: { color: TERRACOTTA },
  stepperClassName: "flex items-center rounded-full bg-white shadow",
  ctaClassName: "min-h-12 flex-1 rounded-full px-5 font-bold text-white shadow-lg focus:outline-none focus:ring-4 focus:ring-white",
  ctaStyle: { backgroundColor: GREEN },
};

const GardenFreshFoodDetailTheme = (props) => <FoodDetailThemeBase {...props} theme={theme} />;

export default GardenFreshFoodDetailTheme;
